"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableRedlineParagraph = exports.EDITABLE_AREA_CLASS = void 0;
exports.proposalColorOf = proposalColorOf;
var _react = _interopRequireWildcard(require("react"));
var _RedlineAuthorColorsContext = require("@common/components/remedy/RedlineAuthorColorsContext");
var _revisionStyle = require("@common/components/remedy/revision-style");
var _proposedRevisions = require("@common/utils/redline/ooxml/proposed-revisions");
var _editableParagraphModel = require("./editable-paragraph-model");
var _editBoxRead = require("./edit-box-read");
var _reportEditBoxFailure = require("./report-edit-box-failure");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function proposalColorOf() {
  return _proposedRevisions.PROPOSED_REVISIONS_HIGHLIGHT;
}
var TYPING_GROUP_MS = 700;
var EDITABLE_AREA_CLASS = exports.EDITABLE_AREA_CLASS = "w-full box-border whitespace-pre-wrap break-words outline-none cursor-text rounded-sm bg-[#F3F4F6] shadow-[0_0_0_3px_#F3F4F6] focus:bg-[#EDEFF3] focus:shadow-[0_0_0_3px_#EDEFF3]";
function withSeparator(node, separator, document) {
  if (separator.length === 0) return node;
  var fragment = document.createDocumentFragment();
  fragment.append(node, document.createTextNode(separator));
  return fragment;
}
function tokenElement(token, proposalColor, userChangeColor, document) {
  if (token.kind === "kept") return document.createTextNode(token.text + token.trailingSeparator);
  var span = document.createElement("span");
  span.textContent = token.text;
  if (token.kind === "inserted") {
    Object.assign(span.style, _revisionStyle.INSERTION_UNDERLINE);
    if (token.author === "user") span.style.color = userChangeColor;else span.style.background = proposalColor;
    return withSeparator(span, token.trailingSeparator, document);
  }
  if (token.author === "engine") span.style.background = proposalColor;else span.style.color = userChangeColor;
  span.style.textDecoration = "line-through";
  span.style.cursor = "pointer";
  span.style.userSelect = "none";
  if (!token.withinWord) span.style.marginRight = "0.25em";
  span.setAttribute(_editableParagraphModel.DELETED_TOKEN_ATTRIBUTE, "true");
  for (var _i = 0, _Object$entries = Object.entries((0, _editableParagraphModel.restoreAttributesOf)(token)); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      attributeName = _Object$entries$_i[0],
      attributeValue = _Object$entries$_i[1];
    span.setAttribute(attributeName, attributeValue);
  }
  span.setAttribute("title", _editableParagraphModel.DELETED_TOKEN_TITLE);
  span.setAttribute("role", "button");
  span.setAttribute("contenteditable", "false");
  return token.withinWord ? withSeparator(span, token.trailingSeparator, document) : span;
}
function historyCarriedOverRead(history, textBoxReadBefore, textOfRead) {
  return {
    entries: history.entries.map(function (entry) {
      var carriedText = (0, _editBoxRead.textCarriedOverRead)(textBoxReadBefore, entry.text, textOfRead).text;
      return {
        text: carriedText,
        caretOffset: entry.caretOffset === null ? null : (0, _editBoxRead.caretOffsetCarriedOver)(entry.text, carriedText, entry.caretOffset)
      };
    }),
    index: history.index,
    lastTypedAtMs: 0
  };
}
function historyAfterPageRead(history, textBoxReadBefore, textOfRead, textShown) {
  try {
    return historyCarriedOverRead(history, textBoxReadBefore, textOfRead);
  } catch (error) {
    (0, _reportEditBoxFailure.reportEditBoxFailure)(error, "carry the undo history over the page read");
    return {
      entries: [{
        text: textShown,
        caretOffset: null
      }],
      index: 0,
      lastTypedAtMs: 0
    };
  }
}
function caretOffsetAfterPageRead(root, textShown, text) {
  try {
    var caretOffsetShown = (0, _editableParagraphModel.caretOffsetIn)(root);
    return caretOffsetShown === null ? null : (0, _editBoxRead.caretOffsetCarriedOver)(textShown, text, caretOffsetShown);
  } catch (error) {
    (0, _reportEditBoxFailure.reportEditBoxFailure)(error, "carry the caret over the page read");
    return null;
  }
}
var EditableRedlineParagraph = exports.EditableRedlineParagraph = function EditableRedlineParagraph(_ref) {
  var origin = _ref.origin,
    text = _ref.text,
    textBoxReads = _ref.textBoxReads,
    proposalColor = _ref.proposalColor,
    ariaLabel = _ref.ariaLabel,
    allowsLineBreaks = _ref.allowsLineBreaks,
    onChange = _ref.onChange,
    onComposingChange = _ref.onComposingChange;
  var rootRef = (0, _react.useRef)(null);
  var composingRef = (0, _react.useRef)(false);
  var historyRef = (0, _react.useRef)({
    entries: [{
      text: text,
      caretOffset: null
    }],
    index: 0,
    lastTypedAtMs: 0
  });
  var textBoxReadsRef = (0, _react.useRef)(textBoxReads);
  var shownTextRef = (0, _react.useRef)(null);
  var shownOriginKeyRef = (0, _react.useRef)(null);
  var originKey = JSON.stringify(origin);
  var userChangeColor = (0, _RedlineAuthorColorsContext.useCurrentUserInsideRedlineColor)();
  var decorate = function decorate(root, textProposed, caretOffset) {
    root.replaceChildren.apply(root, _toConsumableArray((0, _editableParagraphModel.editableTokensOf)(origin, textProposed).map(function (token) {
      return tokenElement(token, proposalColor, userChangeColor, root.ownerDocument);
    })));
    if (textProposed.endsWith("\n")) root.append(root.ownerDocument.createElement("br"));
    shownTextRef.current = textProposed;
    shownOriginKeyRef.current = originKey;
    if (caretOffset !== null) (0, _editableParagraphModel.placeCaretAt)(root, caretOffset);
  };
  (0, _react.useLayoutEffect)(function () {
    var root = rootRef.current;
    if (root === null || composingRef.current) return;
    if (textBoxReads !== textBoxReadsRef.current) {
      historyRef.current = historyAfterPageRead(historyRef.current, textBoxReadsRef.current, textBoxReads, text);
      textBoxReadsRef.current = textBoxReads;
    }
    var shownText = shownTextRef.current;
    if (shownText === text && shownOriginKeyRef.current === originKey) return;
    decorate(root, text, shownText === null ? null : caretOffsetAfterPageRead(root, shownText, text));
  });
  var record = function record(recordedText, caretOffset, continuesTyping) {
    var history = historyRef.current;
    var now = Date.now();
    var replacesLastEntry = continuesTyping && history.index > 0 && history.index === history.entries.length - 1 && now - history.lastTypedAtMs < TYPING_GROUP_MS;
    if (replacesLastEntry) {
      history.entries[history.index] = {
        text: recordedText,
        caretOffset: caretOffset
      };
    } else {
      history.entries = [].concat(_toConsumableArray(history.entries.slice(0, history.index + 1)), [{
        text: recordedText,
        caretOffset: caretOffset
      }]);
      history.index = history.entries.length - 1;
    }
    history.lastTypedAtMs = continuesTyping ? now : 0;
  };
  var applyText = function applyText(root, nextText, caretOffset) {
    decorate(root, nextText, caretOffset);
    onChange(nextText);
  };
  var commit = function commit(continuesTyping) {
    var root = rootRef.current;
    if (root === null) return;
    var nextText = (0, _editableParagraphModel.editedTextOf)(root);
    var caretOffset = (0, _editableParagraphModel.caretOffsetIn)(root);
    if (!composingRef.current) decorate(root, nextText, caretOffset);
    onChange(nextText);
    record(nextText, caretOffset, continuesTyping);
  };
  var stepHistory = function stepHistory(direction) {
    var _entry$caretOffset;
    var root = rootRef.current;
    var history = historyRef.current;
    if (root === null) return;
    var nextIndex = history.index + direction;
    if (nextIndex < 0 || nextIndex >= history.entries.length) return;
    history.index = nextIndex;
    history.lastTypedAtMs = 0;
    var entry = history.entries[nextIndex];
    applyText(root, entry.text, (_entry$caretOffset = entry.caretOffset) !== null && _entry$caretOffset !== void 0 ? _entry$caretOffset : entry.text.length);
  };
  var insertLineBreak = function insertLineBreak() {
    var _caretOffsetIn;
    var root = rootRef.current;
    if (root === null) return;
    var currentText = (0, _editableParagraphModel.editedTextOf)(root);
    var caretOffset = (_caretOffsetIn = (0, _editableParagraphModel.caretOffsetIn)(root)) !== null && _caretOffsetIn !== void 0 ? _caretOffsetIn : currentText.length;
    var nextText = "".concat(currentText.slice(0, caretOffset), "\n").concat(currentText.slice(caretOffset));
    applyText(root, nextText, caretOffset + 1);
    record(nextText, caretOffset + 1, false);
  };
  (0, _react.useEffect)(function () {
    var root = rootRef.current;
    if (root === null) return;
    var onBeforeInput = function onBeforeInput(event) {
      if (event.inputType !== "historyUndo" && event.inputType !== "historyRedo") return;
      event.preventDefault();
      stepHistory(event.inputType === "historyUndo" ? -1 : 1);
    };
    root.addEventListener("beforeinput", onBeforeInput);
    return function () {
      return root.removeEventListener("beforeinput", onBeforeInput);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: rootRef,
    role: "textbox",
    "aria-label": ariaLabel,
    "aria-multiline": allowsLineBreaks,
    contentEditable: true,
    suppressContentEditableWarning: true,
    spellCheck: true,
    onInput: function onInput() {
      return commit(true);
    },
    onCompositionStart: function onCompositionStart() {
      composingRef.current = true;
      onComposingChange === null || onComposingChange === void 0 || onComposingChange(true);
    },
    onCompositionEnd: function onCompositionEnd() {
      composingRef.current = false;
      commit(true);
      onComposingChange === null || onComposingChange === void 0 || onComposingChange(false);
    },
    onKeyDown: function onKeyDown(event) {
      event.stopPropagation();
      var holdsCommandKey = event.metaKey || event.ctrlKey;
      if (holdsCommandKey && event.key.toLowerCase() === "z") {
        event.preventDefault();
        stepHistory(event.shiftKey ? 1 : -1);
        return;
      }
      if (event.ctrlKey && event.key.toLowerCase() === "y") {
        event.preventDefault();
        stepHistory(1);
        return;
      }
      var confirmsComposition = composingRef.current || event.nativeEvent.isComposing;
      if (event.key === "Enter" && !confirmsComposition) {
        event.preventDefault();
        if (allowsLineBreaks) insertLineBreak();
      }
    },
    onClick: function onClick(event) {
      event.stopPropagation();
      var deletedElement = (0, _editableParagraphModel.deletedTokenElementOf)(event.target);
      if (deletedElement === null) return;
      (0, _editableParagraphModel.restoreDeletedToken)(deletedElement);
      commit(false);
    },
    className: EDITABLE_AREA_CLASS,
    "data-sentry-component": "EditableRedlineParagraph",
    "data-sentry-source-file": "EditableRedlineParagraph.tsx"
  });
};